export const CHECKOUT_API_ACCOUNT_ACCESS_ENDPOINTS = {
  freeze: (accountAccessId: string) =>
    `/checkout/account-access/${accountAccessId}/freeze`,
  postProcess: `/checkout/account-access/process`,
  get: (accountAccessId: string) =>
    `/checkout/account-access/${accountAccessId}`,
} as const;

export const GLOBAL_API_ACCOUNT_ACCESS_ENDPOINTS = {
  get: (accountAccessId: string) => `/account-access/${accountAccessId}`,
  patch: (accountAccessId: string) => `/account-access/${accountAccessId}`,
  postCancel: (accountAccessId: string) =>
    `/account-access/${accountAccessId}/cancel`,
} as const;
